<script lang="ts" setup>
import { computed } from 'vue'

import GroupingValidationInfo from '@/stay-displayer/grouping/common/GroupingValidationInfo.vue'
import StayReviewator from '@/stay-displayer/StayReviewator.vue'
import StaySynchronizator from '@/stay-displayer/StaySynchronizator.vue'
import StayValidator from '@/stay-displayer/StayValidator.vue'
import { Stay } from '@/store/modules/stay/types'

const props = withDefaults(defineProps<{
  stay: Stay
  canValidate: boolean
  automationGroupId?: number | null
  isAutomation?: boolean
  isDemoMode?: boolean
}>(), {
  automationGroupId: null,
  isAutomation: false,
  isDemoMode: false,
})

const isValidated = computed(() => props.stay.status === 'validated')
const canValidateInAutomation = computed(() => !props.isDemoMode && props.canValidate)
</script>

<template>
  <div class="grouping-card__action-icons">
    <stay-reviewator
      v-if="!isValidated"
      :stay="stay"
    />
    <stay-synchronizator :stay="stay" />
  </div>

  <grouping-validation-info
    v-if="isValidated"
    :stay="stay"
  />

  <template v-if="isAutomation">
    <!-- BUILD-487: bouton "Mode manuel" retiré temporairement (applique le mauvais codage) -->
    <div
      v-if="isValidated"
      class="grouping-card__cancel-row"
    >
      <!--<automation-disabler :stay="stay" />-->
      <stay-validator
        v-if="canValidateInAutomation"
        :stay="stay"
      />
    </div>
    <template v-else>
      <stay-validator
        v-if="canValidateInAutomation"
        :stay="stay"
        :automation-group-id="automationGroupId"
        class="w-100"
      />
      <!--<automation-disabler :stay="stay" />-->
    </template>
  </template>

  <stay-validator
    v-else-if="canValidate"
    :stay="stay"
    :class="{ 'w-100': !isValidated }"
  />
</template>
